import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { MatchingEndingAnswerProps } from '../../../../../student-do-test-questions/MatchingEndingAnswer';
import { useTestSubmissionStore } from '../../../../model/test-submissions.hook';
import { DoTestQuestionMatchingMobile } from '../DoTestQuestionMatchingMobile';

export const DoTestMatchingEndingMobile = observer((props: MatchingEndingAnswerProps) => {
  const { data } = props;
  const {
    formattedQuestionNo,
    onRemoveAnswerAtIndex,
    userAnswers,
    options,
    endingOptions,
    onAnswerQuestion,
  } = data;

  const store = useTestSubmissionStore();
  return (
    <DoTestQuestionMatchingMobile
      title="Endings"
      options={options}
      onRemoveAnswerAtIndex={onRemoveAnswerAtIndex}
      onAnswerQuestion={(input) => {
        if (store.preventUserAction()) return;
        onAnswerQuestion(input);
      }}
      questionList={endingOptions}
      userAnswers={userAnswers}
      formattedQuestionNo={formattedQuestionNo}
    />
  );
});
